export default {
  common: {
    selectAll: '全選',
    cancel: '取消',
    comfirm: '確認',
    action: '操作',
    edit: '編輯',
    delete: '刪除',
    reminder: '追單',
    reminder2: '追單',
    detail: '查看詳情',
    print: '打印',
    warning: '警告',
    warning2: '提示',
    clear: '清空',
    set: '設置',
    setting: '設置',
    tips: '提示',
    hanldeIsDangerous: '正在進行危險操作！',
    uploadFailed: '上傳失敗！請重試！',
    printOrder: '打印賬單',
    pay: '結賬',
    refund: '退款',
    yes: '是',
    no: '否',
    handleSuccess: '操作成功',
    closeWarning: '確認關閉餐廳運營系統頁面（非結束運營）？',
    netError: '當前網絡不佳，請稍等 （你可能需要檢查剛剛操作的訂單）',
    netErrorTryAgain: '網絡不佳，請重試',
    netErrorCheck: '網絡不佳，請檢查',
    loginByOtherDriver: '已有其他設備登錄了您的帳號',

    tax: '消費稅',
    tax2: '消費稅',
    tip: '小費',
    packageFee: '餐盒費',
    serviceFee: '服務費',
    tipServiceFee: '小費/服務費',
    price: '小計',
    discount: '已優惠',
    discounttakeaway: '外賣折扣',
    discounttakeaway2: '外賣折扣',
    total: '總計',
    totalBill: '訂單總計',
  },
  error: {
    illegalPage: '非法页面',
  },
  index: {
    inBusiness: '營業中',
    outBusiness: '未營業',
    deviceStatus: '設備狀態',
    deviceError: '設備異常！',
    viewDetail: '查看詳情',
    errorReason: '異常原因',
    remindMe10: '十分鐘後提醒我',
    remindMe30: '半小時後提醒我',
    remindMe60: '一小時後提醒我',
    remindMe180: '三小時後提醒我',
    remindMe24: '明天提醒我',
    monitor: '觸控台',
    reader: '刷卡機',
    printer: '打印機',
    linkOk: '連接',
    linkError: '異常',
    linkFail: '離線',
    thisOne: '本機',
    paperOut: '紙張不夠',
    startBusiness: '開始營業',
    currentScene: '當前場景',
    noScene: '無場景',
    toggloFullScreen_false: '切換全屏',
    toggloFullScreen_true: '退出全屏',
    dateControl: '手動日期控制',
    editPassword: '修改密碼',
    myFeedback: '我的反饋',
    lock: '鎖定屏幕',
    logout: '登出',
    logoutConfirm: '確認登出？ ',
    errorMessage: '店鋪信息錯誤，請重新登入',
    orderDeteled: '訂單已被刪除',
    // orderNewNeedHandle: '您有新的落單審核需要處理',
    // clickThenJumpToOrderNew: '點擊跳囀到落單審核頁面',
    cash1: '現金',
    cashInAndOut: '現金收入與支出',
    inputCash: '請輸入現金',
    cashIn: '現金收入',
    cashOut: '現金支出',
    inputOtherReason: '請輸入其他原因',

    notFindPrivilege: '權限查詢失敗，請重試',

    feedback: '報告錯誤',
    home: '主頁',
    table: '餐桌',
    menu: '菜單',
    lineup: '排隊取號',
    order: '訂單管理',
    items: '庫存管理',
    shop: '店鋪狀態',
    qrcode: '二維碼管理',
    member: '會員管理',
    orderNew: '落單審核',
    book: '預訂管理',
    cash: '現金管理',
  },
  menu: {
    takeaway: '外賣',
    tangshi: '堂食',
    // tableNo: '枱號',
    unit: '份',
    remarks: '備註',
    sendKitchen: '發送廚房',
    printOrder: '打印收據',
    calc: '結賬',
    name: '姓名',
    phone: '聯絡電話',
    inputItemName: '請輸入菜名',
    cartIsEmpty: '購物籃為空',
    all: '全部',
    hot: '熱門推介',
    multi: '多選',
    required: '必選',
    specLimit1: '必填 ',
    specLimit2: '可選 ',
    specLimit3: '必填，可選 ',
    min: '最少',
    max: '最多',
    selectSpec: '已選擇',
    refresh: '更新購物籃',
    refreshAndSend: '更新購物籃並發送',
    add: '加入購物籃',
    cart: '購物籃',
    addItemWarning: '不能加入購物籃，請檢查您的選擇',
    customFood: '特别菜',
    customFoodName: '名稱',
    customFoodNamePlanceholder: '請輸入名稱',
    customFoodPrice: '價格',
    customFoodPricePlanceholder: '請輸入價格',
    customFoodPrinter: '請選擇打印',
    customFoodPrinterPlanceholder: '請選擇打印',
    off9: '九折',
    off8: '八折',
    off5: '五折',
    off11: '服務費10%',
    off12: '服務費20%',
    off13: '服務費30%',
    timePrice: '時價',
    timePriceFood: '時價菜',
    pickupTime: '取餐時間',
    hour: '時鐘',
    minute: '分鐘',
    now: "馬上",
    sceneMustSelect: "請選擇菜單",
    sceneChangeWarning: "若要切換菜單，請點擊下方購物籃標題裡的菜單",
    reminderSentSuccess: "追單已發送廚房",
  },
  coupon: {
    coupons: '優惠碼',
    discountCode: '折扣',
    inputDiscountCode: '請輸入優惠碼',
    noCoupon: '無優惠券',
    cannotBind: '不可綁定',
    used: '已使用',
    expired: '已過期',
    value: '優惠',
    applicableShop: '適用店鋪',
    applicableFood: '適用菜品',
    validityTime: '有效期',
    restrictions: '限制條件',
    termsOfUse: '使用條款',
  },
  pay: {
    payTypeIsEmpty: '未查詢到支付方式，請檢查 DoLA Dashboard 設置 ',
    payResult: '付款結果',
    payWay: '付款方式',
    paySuccess: '付款成功',
    finPay: '已完成付款',
    payCardComfirm: '支付確認',
    payCardComfirmTip: '若已確認收款，請點擊確認收款按鈕',
    payComfirm: '確認收款',
    payNot: '未收款',
    eftPayFailed: 'EFT刷卡機支付失敗！',
    eftRefundFailed: 'EFT刷卡機退款失敗！',
    eftPayTimeOut: 'EFT刷卡機支付超時！',
    eftPayLastPending: '上一筆EFT刷卡機付款結果未知，請先和顧客確認是否已經扣款再付款',
    eftPayLastSuccessed: '通知：上一筆EFT刷卡機付款成功',
    eftPayLastFailed: '通知：上一筆EFT刷卡機付款失敗',
    eftPayIsNotSupport: 'DoLA POS網頁版不支援刷卡機',
  },
  calc: {
    calcWay: '付款方式',
    tip: '請確認優惠券填寫無誤後，再點擊付款方式！ ',
    calcWay1: '全部結賬',
    calcWay2: '分錢結賬',
    calcWay3: '分菜結賬',
    totalPrice: '訂單總金額',
    total: '總金額',
    unassigned: '未分配',
    unpaidPrice: '未付金額',
    byPerson: '按人數分賬',
    byCustom: '按金額分賬',
    inputEatCount: '請輸入分賬人數',
    inputCustomPrice: '請輸入自訂金額',
    inputCustomPrice_cashdialog: '請輸入自訂金額',
    payLeft: '支付剩餘金額',
    payStatus1_: '未付',
    payStatus2_: '已付',
    payStatus1: '未付金額',
    payStatus2: '已付金額',
    unit: '人',
    cancelCalcAndRefund: '撤銷當前結賬並全部退款',
    cancelCalc: '撤銷當前結賬',
    haveChosenPayDirectly: '已選擇全部結賬',
    haveChosenPayByMoney: '已選擇分錢結賬',
    haveChosenPayByFood: '已選擇分菜結賬',
    haveChosenPayByPerson: '已選擇按人數分賬',
    haveChosenPayByCustom: '已選擇按金額分賬',
    paidPartByFood: '分菜 - 部分已結賬',
    paidPartByPerson: '按人數分賬 - 部分已結賬',
    paidPartByCustom: '按金額分賬 - 部分已結賬',
    couponError: '優惠券錯誤',
    totalError: '超出總金額',
    received: '現金付款',
    change: '找贖',
    payCashNotEnough: '輸入金額小於應付金額，請重新輸入',
    personNumberError: '您輸入的人數有誤，請重新輸入',
    personNumberExceedsLimit: '請輸入小於或等於20的人數',
    moneyNumberError: '您輸入的金额有誤，請重新輸入',
    couponHasInputedOnlyCanCalcAll: '若要開始分菜结账，請取消優惠券',
    memberHasBoundOnlyCanCalcAll: '若要開始分菜结账，請取消會員關聯',
    shouldPay: '應付',
    changePayTypeAfterPaid: '修改支付方式',
  },
  food: {
    food: '分菜結賬',
    childOrderNum: '已分單',
    paid: '已付款',
    deleteTip: '當前帳單菜品將被移回到原始帳單。請確認是否繼續? ',
    cancelCalc: '撤銷當前結賬',
    order: '賬單',
    finPay: '已完成付款',
    noItem: '無商品',
    choice: '可選',
    add: '加入',
  },
  feedback: {
    feedback: '報告錯誤',
    title: '標題',
    content: '內容',

    feedbackList: '反饋清單',
    index: '編號',
    shortdate: '日期',
    status: '狀態',
    dealPerson: '反饋人',

    status1: '未答復',
    status2: '已答復',
    status3: '已解決',

    feedbackTime: '反饋時間',
    inputReply: '請輸入回復內容',
    reply: '回復',
    platform: '平台',
  },
  key: {
    psd: '二級密碼',
    inputPsd: '請輸入二級密碼',
    inputWaiterPsd: '請輸入二級密碼',
    selectReason: '請選擇原因',
    reason1: '客人退菜',
    reason2: '庫存不足',
    reason3: '服務員錯誤操作',
    reason4: '其他',
    editDateWarning1: '請注意：',
    editDateWarning2: '修改日期後，日期將不會自動跳轉直到閉店',
    currentDate: '當前日期',
    editDate: '修改日期',
    day1: '星期一',
    day2: '星期二',
    day3: '星期三',
    day4: '星期四',
    day5: '星期五',
    day6: '星期六',
    day7: '星期日',
  },
  home: {
    takeaway: '外賣',
    seat: '餘位',
    tableNo: '枱號',
    tableSeparate: '開枱',
    updateCount: '更新人数',
    personCount: '人數',
    waiter: '服務員',
    printQRCode: '打印二維碼',
    scanQRCode: '掃碼點餐',
    tableCancel: '取消開枱',
    order: '點餐',
    pay: '付款',
    detail: '查看詳情',
    eatCount: '就餐人數',
    eatCountUnit: '位',
    tableMove: '轉枱',
    left: '剩餘',
    tableShare: '搭枱',
    form: '從',
    moveTo: '移動到',
    tableSelect: '選擇餐枱',
    orderSelect: '選擇訂單',

    tableSatus1: '空枱/已結賬',
    tableSatus2: '就餐中',
    tableSatus3: '已部分結賬',
    tableSatus4: '已部分發送',
    noSelect: '未選擇',

    inputEatCount: '請輸入就餐人數',
    errorMessage: '超出人數',

    noTable: '餐枱未配置',
  },
  line: {
    navs1: '快速取號',
    navs2: '排隊清單',

    lineup: '取號',
    eatCount: '就餐人數',
    contract: '聯絡電話',
    currentNo: '當前叫號',
    nextNo: '下一個叫號',
    unit1: '號',
    waitCount: '前方等候',
    unit2: '桌',
    newNo: '最新排號',
    nextTable: '下一桌',
    none: '無',
    unit: '人',
    lineCode: '取號碼',
    createTime: '排隊時間',

    index: '編號',
    codeNo: '排隊號',
    persons: '人數',
    phone: '聯絡電話',

    passNo: '過號',

    lineupSuccess: '取號成功',
    inputEatCount: '請填寫就餐人數',
    inputContract: '請填寫聯絡電話',
  },
  orderNew: {
    orderNewManage: '落單審核',
    agreeOrder: '同意並點餐',
    agreePay: '同意並結帳',
    agree: '同意',
    refuse: '拒绝',
    agreed: '已同意',
    refused: '已拒绝',
    detail: '详细',
  },
  order: {
    orderManage: '訂單管理',
    orderManage2: '失效訂單',
    searchContent: '單號/電話',
    searchContent2: '掃碼槍輸入',
    search: '搜尋',

    selectAll: '全選',
    payWay: '付款方式',
    payWay1: '微信',
    payWay2: '支付寶',
    payWay3: 'Mastercard',
    payWay4: 'Visa',
    payWay5: '現金',
    payWay6: 'Apple Pay',
    payWay7: 'Google Pay',
    payWay8: '八達通',
    payWay9: '銀聯',
    payWay10: 'Amex',
    payWay11: 'Stripe',
    payWay12: '信用卡',
    payWay13: '支票',
    orderType: '訂單分類',
    orderType1: '堂食',
    orderType2: '外賣',
    orderType3: '外賣平台',
    orderType4: '堂食', // 總二維碼點餐
    payStatus: '支付狀態',
    payStatus01: '已合并',
    payStatus0: '已退款',
    payStatus1: '未付款',
    payStatus2: '已付款',
    payStatus3: '無小費',
    detail: '詳情',

    index: '單號',
    shortdate: '日期',
    codeText: '枱號/電話/姓名',
    orderTypeText: '訂單分類',
    userCost: '金額',
    payway: '付款方式',

    orderDetail: '訂單詳情',
    calcWay: '付款方式',
    unit: '人',
    orderNo: '單號',

    itemName: '菜品明細',
    count: '數量',
    itemPrice: '金額',
    takeoutText: '外賣',
    remarks: '備註',

    calcWay0: '未選擇',
    calcWay1: '全部結賬',
    calcWay2: '分錢結賬 - 按人數',
    calcWay3: '分錢結賬 - 自訂金額',
    calcWay4: '分菜結賬',

    mustSelect: '請先選擇訂單',

    backMenu: '回到菜單',
  },
  item: {
    itemManage: '庫存管理',
    sellOutCancel: '取消全部售罄',
    sellOut: '全部售罄',
    all: '全部',
    hot: '熱門推介',
    hide: '已售罄',
    yu: '餘',
    stockError: '餘量不足',
    stockSet: '餘量設置',
    stockSetClear: '取消餘量設置',
    stockSetDesc: '請輸入該菜品的剩餘數量',
    minCostLimited1: '最低點餐金額為$',
    minCostLimited2: '，請檢查您的選擇',
  },
  shop: {
    shopStatus: '店鋪營業狀態',
    inBusiness: '開始營業',
    outBusiness: '停止營業',
    printReport: '打印報告',
    isContinueClosing: '有訂單未結帳，請確認是否繼續。',
    isContinueClosing2: '有未處理的訂位信息，請在閉店前處理',
    isPrintClosingReport: '是否打印今日營業報告？',
    closingReport: '今日營業報告',
    printDetail: '打印詳細報告',
    printAll: '打印總報告',
    printDish: '菜品報告',
    printCash: '現金流水報告',

    cash: '現金',
    wechat: '微信',
    alipay: '支付寶',
    card: '信用卡',
    cheque: '支票',
    octopus: '八達通',
    stripe: 'Stripe',
    tangshi: '堂食',
    takeout: '自營外賣',
    platform: '外賣平台',
    all: '總額',
    type: '品類',

    closeing: '閉店中…',
    waitingCloseing: '訂單處理中，請稍候…',
    continue: '继续',
    faildReason: '的小費扣款失敗，原因：',
    pleaseEdit: '，請修改小費',
  },
  qrcode: {
    qrcodeInvalidManage: '二維碼失效管理',
    qrcodeTable: '餐桌二維碼',
    qrcodeTangshi: '總二維碼（堂食）',
    qrcodeLine: '排隊二維碼',
    qrcodeTakeaway: '總二維碼（外賣）',
    open: '開啟',
    close: '關閉',
    '1hour': '1小時',
    '2hour': '2小時',
    '4hour': '4小時',
    '8hour': '8小時',
    utillClose: '直到關店',
  },
  login: {
    toggloFullScreen_false: '切換全屏',
    toggloFullScreen_true: '退出全屏',
    inputName: '請輸入賬戶',
    inputPsd: '請輸入密碼',
    login: '登入',

    inputYourName: '请输入用户名',
    inputYourPsd: '请输入密码',
    notBindShop: '該賬號未綁定分店',
    loginWithManagerAccount: '請使用經理賬號登錄',

    inBusiness: '開始營業',
    outBusiness: '未營業',
    isOpen: '是否開始營業',
    selectShop: '選擇分店',

    clearSellout: '存在售罄的菜品',
    clearSelloutNot: '不恢復',
    clearSelloutOk: '全部恢復',

    clock: '員工打卡',
    enter: '進入',
    enterPos: '進入POS',
    finish: '完成',
    welcome: '您好，',
    youNeed: '您需要：',
    workinClock: '上班打卡',
    workoutClock: '下班打卡',
    restStart: '開始休息',
    restEnd: '結束休息',
    date: '日期',
    workin: '上班',
    workout: '下班',
    resttime: '休息 (mins)',
    worktime: '工作時長 (hrs)',
    workStatus1: '未工作',
    workStatus2: '工作中',
    workStatus3: '休息中',
    noCameraWarning: '未能檢測到攝像頭，請檢查是否授權',
  },
  reader: {
    readerError1: '刷卡機斷開連接',
    readerError2: '找不到刷卡機 （異常101）',
    readerError3: '找不到刷卡機 （異常102）',
    readerError4: '找不到該設備指定的刷卡機 ',
    readerError5: '刷卡機連接失敗',
    readerError6: '刷卡失敗，請重試',
    readerError7: '結帳失敗，請使用另外一張卡',
    readerWaiting: '請使用刷卡機完成付款...',
  },
  print: {
    batchPrint: '分單打印',
    mergePrint: '合併打印',
    selectYourPrintWay: '請選擇您的打印方式',
    mergeWarningMessage1: '選中的訂單將被合併且不能撤銷',
    mergeWarningMessage2: '請確認是否繼續？',
    printerError: '打印機異常',
    partOrderIsPaid: '部分訂單已進入支付',
    orderIsPaid: '訂單已支付',
    foodNotSent: '有菜品未發送廚房，是否繼續完成付款？',
  },
  scan: {
    scanResult: '掃描結果',
    rescan: '重新掃描',
    waitingScaning: '等待掃描',
    resetScaning: '請點擊重新掃描按鈕',
    scanFailedScanAgain: '掃描失敗，請重新掃描',
    scanFailedNotFoundOrder: '訂單未找到，請重試',
  },
  member: {
    member: '會員',
    memberAccount: '會員賬戶',
    vip: 'VIP',
    becomeVip: '加入VIP',
    payVip: '付費VIP',
    search: '搜尋',
    searchContent: '請輸入手機/電郵/掃描會員二維碼',
    notFindMember: '未查詢到顧客信息！',
    updateVip: '升級VIP',
    renewVip: '續費VIP',
    calc: '結賬',
    bindMember: '會員',
    bindMemberAndCalc: '選擇會員並結算',
    memberId: 'ID',
    memberNickname: '暱稱',
    memberLevel: '等級',
    memberPhone: '手機',
    memberEmail: '電郵',
    memberVipEndTime: 'VIP到期時間',
    memberScore: '積分',
    memberBalance: '余額',
    charge: '增值',
    chargeAmount: '增值金額',
    giveAmount1: '贈送',
    giveAmount2: '',
    giveScore1: '附送',
    giveScore2: '分',
    giveCoupons: '附送优惠券',
    bill: '賬單',
    balanceChangeType1: '增值',
    balanceChangeType2: '堂食消費',
    balanceChangeType3: '外卖消費',
    balanceChangeType4: '外賣平台消費',
    balanceChangeType5: '增值贈送',
    balanceChangeType6: '商家修改',
    balanceChangeType7: '續費VIP',
    balanceChangeType8: '商品郵費',
    balanceChangeType9: '退款',
    year: '年',
    month: '月',
    time: '時間',
    mustCost: '總計',
  },
  report: {
    address: '地址',
    phone: '電話',
    date: '日期',

    payWay: '支付方式',
    tangshi: '堂食',
    takeaway: '外賣',
    all: '總額',

    turnover: '營業額',
    turnoverTip: '含稅',

    serviceFee: '服務費',
    tipsFee: '小費',
    consumptionFee: '消費稅',
    packageFee: '餐盒費',
    takeoutDiscountFee: '外賣折扣',
    discountFee: '優惠券',
    count: '數量',
    amount: '金額',

    unPayed: '未支付',
    returnCash: '已退款',

    dinners: '客流量',
    orderNumber: '總訂單',
    deleteOrderNumber: '刪除訂單',
    deleteOrderItemNumber: '刪除菜品',
    tangshiOrderNumber: '餐廳堂食',
    takeoutOrderNumber: '餐廳外賣',
    takeoutPlatNumber: '外賣平台',

    unitPerson: '人',
    unitCount: '個',
    unitOrder: '單',

    memberReport: '會員報告',
    payWay2: '支付方式',
    memberFee: '會員費',
    memberSellFee: '會員+銷售',

    total: '總計',
    netRevenue: '凈營收',
    netRevenueTip: '不含稅',
    revenue: '營收',
    revenueTip: '含稅',

    cashInAndOut: '現金收入與支出',
    cashIn: '總收入',
    cashOut: '總支出',
    detailRecords: '詳細紀錄',
    reason: '原因',
    time: '時間',

    combo: '套餐',
    dish: '菜品',
    comboDel: '刪除套餐',
    dishDel: '刪除菜品',
  },
  book: {
    bookList: '預訂表格',
    bookApprove: '預訂審批',
    bookManage: '預訂管理',
    timeSetting: '時段設定',
    createBook: '新增預訂',
    today: '今天',
    tomorrow: '明天',
    all: '全部',

    seat: '位',
    contract: '聯絡人',
    bookTime: '預訂時間',
    phoneNumber: '聯絡電話',
    remark: '備註',
    createTime: '創建時間',

    accept: '同意',
    refuse: '拒絕',
    arrival: '確認到店',
    unarrival: '未到店',
    cancel: '取消',
    queryCancel: '請求取消',
    acceptCancel: '同意取消',
    refuseCancel: '拒絕取消',

    approve: '待接受',
    accepted: '待到店',
    refused: '已拒絕', // 管理系统 = 预定失败
    arrivaled: '已到店',
    canceled: '已取消',
    success: '預訂成功',
    fail: '預訂失敗',

    refuseReason: '拒絕理由',
    full: '預訂已滿',
    pause: '暫停預訂',
    otherReason: '其他原因',
    inputOtherReason: '請輸入其他原因',

    book: '預訂',
    bookShop: '分店',
    bookNumber: '人數',
    bookWhole: '包場',
    bookTimeIsRequired: '請選擇預訂時間',
  },
  remark: {
    remark: '備註',
    presetRemark: '預設備註',
    inputRemark: '請輸入備註',
  },
}
